export default "__VITE_ASSET__BjAQqUJO__"